function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("clipPath", {
  id: "facebook_svg__a",
  transform: "translate(0 .03)"
}, React.createElement("path", {
  className: "facebook_svg__a",
  d: "M0 0h30.22v30H0z"
})), React.createElement("style", null, ".facebook_svg__a{fill:none}"));

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  className: "facebook_svg__a",
  d: "M0 .03h30.22v30H0z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#facebook_svg__a)"
}, React.createElement("path", {
  d: "M30.22 15.12a15.11 15.11 0 10-17.47 14.91V19.48H8.91v-4.36h3.84V11.8c0-3.77 2.25-5.88 5.71-5.88a24 24 0 013.38.3v3.71h-1.91a2.18 2.18 0 00-2.45 1.88 1.93 1.93 0 000 .48v2.83h4.19L21 19.48h-3.53v10.55a15.11 15.11 0 0012.75-14.91",
  fill: "#1877f2"
}));

function SvgFacebook(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 30.22 30.03"
  }, props), _ref, _ref2, _ref3);
}

export default __webpack_public_path__ + "assets/images/facebook.5ab7bb29.svg";
export { SvgFacebook as ReactComponent };